import React from 'react';
import { Inner, Wrapper } from './PipsItem.styles';
import { Props } from './PipsItem.types';

const PipsItem = (props: Props) => (
  <Wrapper hide={!props.inStep || !props.fullHour}>
    <Inner>{props.children}</Inner>
  </Wrapper>
);
export default PipsItem;
